import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { timestamp } from 'rxjs/operators';

import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pagare-principal',
  templateUrl: './pagare-principal.component.html',
  styleUrls: ['./pagare-principal.component.css']
})
export class PagarePrincipalComponent implements OnInit {
  public showError = false
  public error = ''
  public input = false
  private identity
  constructor(private dialogRef: MatDialogRef<PagarePrincipalComponent>,
    private _userService: UserService,
    private spinner: NgxSpinnerService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }


  async ngOnInit() {
    this.identity = await JSON.parse(this._userService.GetsessionStorage('identity'));
  }

  cerrar() {
    this.dialogRef.close({ data: false });
  }

  generaToken() {
    console.log(this.data)

    this.spinner.show()

    let dataValida = {
      numsol: this.data.solicitud.NUMSOL,
      codunico: this.identity.CODUNICO
    }

    this._userService.httpPost('validaFirmaDeceval', dataValida).subscribe(resp => {
      if (resp.status == 'success') {
        this.alamacenarDatosGirador((err, datosGirador) => {

          if (!err) {
            console.log('entró aqui');
            const datosAlmacenarPagare = {
              numsol: this.data.solicitud.NUMSOL,
              monto: this.data.solicitud.MONTO,
              nit: this.identity.NIT,
              codasociado: this.identity.CODASOCIADO,
              codunico: this.identity.CODUNICO
            };
            if (datosGirador.status === 'success') {
              this._userService.httpPost('almacenarDatosPagare', datosAlmacenarPagare).subscribe(response => {
                if (response.status === 'success') {
                  const datosToken = {
                    nombres: this.identity.NOMBRES + ' ' + this.identity.APELLIDOS,
                    nit: this.identity.NIT,
                    email: this.identity.EMAIL1,
                    //email: 'esteban.boada17@gmail.com',
                    numsol: this.data.solicitud.NUMSOL,
                    codunico: this.identity.CODUNICO,
                  };
                  this._userService.httpPost('generarTokenPagare', datosToken).subscribe(async resul => {
                    this.spinner.hide();
                    if (resul.status === 'success') {
                      Swal.fire({
                        icon: 'success',
                        text: resul.message
                      })
                      this.input = true;
                    } else {
                      Swal.fire({
                        icon: 'error',
                        text: resul.message
                      })
                    }
                  }, error => {
                    this.spinner.hide();
                    Swal.fire({
                      icon: 'error',
                      text: error
                    })
                  });

                } else {
                  this.spinner.hide()
                  Swal.fire({
                    icon: 'error',
                    text: response.message
                  })
                }
              }, error => {
                this.spinner.hide()
                Swal.fire({
                  icon: 'error',
                  text: error
                })
              });
            } else {
              this.spinner.hide()
              Swal.fire({
                icon: 'error',
                text: err
              })
            }
          }else{
            this.spinner.hide()
            Swal.fire({
              icon: 'error',
              text: err
            })
          }
        });
      } else {
        this.spinner.hide()
        Swal.fire({
          icon: 'warning',
          text: resp.message
        })
      }
    },
      error => {
        this.spinner.hide();
      })


  }

  alamacenarDatosGirador(cb) {
    const datos = {
      codasociado: this.identity.CODASOCIADO,
      numsol: this.data.solicitud.NUMSOL,
      codunico: this.identity.CODUNICO
    };

    console.log("Milton: ", datos);
    this._userService.httpPost('almacenarDatosGirador', datos).subscribe(resp => {
      console.log("miltonnn", resp);
      if (resp.status === 'success') {
        //localStorage.setItem('numidentificacionDeceval', resp.details);
        return cb(null, resp);
      } else {
        return cb(resp.message);
      }
    }, error => {
      //alert(JSON.stringify(error as any));
      return cb(JSON.stringify(error as any))
    });
  }

  validaToken(forma) {
    if (forma.form.value.token != null) {
      this.spinner.show();
      const datosConfirmacion = {
        numsol: this.data.solicitud.NUMSOL,
        codunico: this.identity.CODUNICO,
        token: forma.form.value.token
      };

      this._userService.httpPost('validarTokenPagare', datosConfirmacion).subscribe(async response => {
        console.log(response);
        if (response.status == 'success') {
          this.realizarFirmaPagare(forma.form.value.token, (err, resp) => {
            this.spinner.hide();
            if (resp.status == 'success') {
              Swal.fire({
                icon: 'success',
                text: resp.message
              })
              this.dialogRef.close({ data: false });
            } else {
              Swal.fire({
                icon: 'error',
                text: resp.message
              })
              this.dialogRef.close({ data: false });
            }
          });
        } else {
          this.spinner.hide();
          Swal.fire({
            icon: 'error',
            text: response.message
          })
        }

      }, error => {
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          text: error
        })
        console.log(error);
      }
      );

    } else {
      Swal.fire({
        icon: "error",
        text: "Por favor complete los campos para continuar"
      })

    }
  }

  realizarFirmaPagare(token, cb) {
    const datos = {
      codunico: this.identity.CODUNICO,
      numsol: this.data.solicitud.NUMSOL,
      nit: this.identity.NIT,
      token: token
    };
    this._userService.httpPost('firmarPagare', datos).subscribe(result => {
      return cb(null, result);
    }, error => {
      this.spinner.hide();
      console.log(error);
    });
  }

}
